import React, { useEffect, useState } from "react";
import { Bookmark, BookmarkCheck } from "lucide-react";
import api from "@/lib/api";
import { PageContainer, PageHeader } from "@/components/Page";

const Recommendations = () => {
  const [tab, setTab] = useState("recommendations");
  const [filter, setFilter] = useState("Organic Viral");
  const [items, setItems] = useState([]);
  const [saved, setSaved] = useState({});

  useEffect(() => { api.get("/social/recommendations").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);

  const filtered = tab === "saved" ? items.filter((i) => saved[i.id]) : items.filter((i) => i.category === filter);

  return (
    <PageContainer>
      <PageHeader title="Social Media Recommendations" subtitle="Trending video ideas tailored for you." testId="social-recs-header" />
      <div className="flex gap-2 mb-6 border-b border-gray-200">
        {["recommendations", "saved"].map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`px-4 py-2 text-sm font-medium border-b-2 capitalize ${tab === t ? 'border-[#7C3AED] text-[#7C3AED]' : 'border-transparent text-gray-600'}`} data-testid={`tab-${t}`}>{t}</button>
        ))}
      </div>
      {tab === "recommendations" && (
        <div className="flex gap-2 mb-6">
          {["Organic Viral", "Winning Ads"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={filter === f ? "op-pill-active" : "op-pill-inactive"} data-testid={`filter-${f.replace(/\s/g,'-').toLowerCase()}`}>{f}</button>
          ))}
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((i) => (
          <div key={i.id} className="op-card overflow-hidden" data-testid={`rec-card-${i.id}`}>
            <div className="aspect-video bg-gray-100"><img src={i.thumb} alt="" className="w-full h-full object-cover" onError={(e) => e.target.style.display = 'none'} /></div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 rounded-full bg-purple-100 text-[#7C3AED] text-xs font-semibold mb-2">{i.category}</span>
              <p className="font-semibold text-gray-900 mb-3">{i.title}</p>
              <div className="flex gap-2">
                <button className="op-btn-primary text-xs py-1.5 flex-1 justify-center">Use this idea →</button>
                <button onClick={() => setSaved((s) => ({ ...s, [i.id]: !s[i.id] }))} className="op-btn-secondary text-xs py-1.5 px-3" data-testid={`save-${i.id}`}>
                  {saved[i.id] ? <BookmarkCheck size={14} /> : <Bookmark size={14} />}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </PageContainer>
  );
};
export default Recommendations;
